import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreateCusotmerAddressStep from "./CreateCusotmerAddressStep";
import AddressSearchMap from "../../../../../components/AddressSearchMap/AddressSearchMap";
import { setOrder } from "../../../../../redux/OrderData/OrderData";
import HubIcon from "../../../../../assets/icons/HubIcon";
import BoxiAddresses from "./BoxiAddresses";

interface SelectAddressStepProps {
  AddressStep: number;
  setAddressStep: (value: number) => void;
  setOuterOpen: (value: boolean) => void;
}

const SelectAddressStep = ({
  AddressStep,
  setAddressStep,
  setOuterOpen,
}: SelectAddressStepProps) => {
  const [Address, setAddress] = useState<any>();
  // const [Addresses, setAddresses] = useState([]);
  const [EditAddress, setEditAddress] = useState(false);
  const [SenderType, setSenderType] = useState(true);

  const { orderData } = useSelector((state: any) => state.Order);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   getAPI(
  //     `${getUrls.findAddressByCity}${[orderData.senderCustomerId]}&cityid=${orderData.fromCountryDevisionId}`
  //   ).then((res) => setAddresses(res.data.payload));
  // }, [orderData.fromCountryDevisionId, orderData.senderAddressId, orderData.senderCustomerId]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      lat: null,
      lng: null,
      address: "",
    },
    onSubmit: () => {},
  });

  const { values, handleReset, setFieldValue }: any = formik;

  useEffect(() => {
    values.address && SenderType && setAddressStep(3);
  }, [SenderType, setAddressStep, values]);

  // const handleEditAddress = () => {
  //   setFieldValue("lng", Address?.longtitude);
  //   setFieldValue("lat", Address?.latitude);
  //   setFieldValue("address", Address?.address);
  //   setEditAddress(true);
  //   setAddressStep(3);
  // };

  const CreateAddress = (data: any) => {
    // Destination
    if (data) {
      dispatch(
        setOrder({
          returnAddressId: data.id,
          returnAddressName: data.address,
          returnAddressTitle: data?.name,
          returnAddressPostalCode: data?.postalCode,
          returnAddressDetail: data?.addressDetail,
          returnLat: data?.latitude,
          returnLng: data?.longtitude,
          returnHubId: undefined,
          returnHubName: undefined,
          returnHubAddress: undefined,
        })
      );
      setOuterOpen(false);
      setAddressStep(2);
      setAddress(undefined);
      handleReset();
      // });
    }
  };

  const CloseModal = () => {
    setOuterOpen(false);
    setAddressStep(2);
  };

  return (
    <div className="flex Max-sm:flex-col-reverse gap-5">
      {SenderType ? (
        AddressStep === 2 ? (
          // <div className="sm:w-96 flex flex-col min-h-[36rem]">
          //   <div>
          //     <p className="text-dark mb-4">آدرس های ذخیره شده</p>
          //     {Addresses.length > 0 ? (
          //       <div className="flex flex-col gap-3 overflow-auto max-h-[26rem]">
          //         {Addresses.map((item: any) => (
          //           <AddressElements
          //             setFieldValue={setFieldValue}
          //             item={item}
          //             handleEditAddress={handleEditAddress}
          //             Address={Address}
          //             setAddress={setAddress}
          //           />
          //         ))}
          //       </div>
          //     ) : (
          //       "آدرسی برای کاربر ثبت نشده است"
          //     )}
          //   </div>
          //   <div className="btnForm ">
          //     <SimpleButton
          //       handelClick={CloseModal}
          //       className="full-lightTomato-btn w-full"
          //       text="لغو"
          //     />
          //     <SimpleButton
          //       handelClick={() => CreateAddress(Address)}
          //       className="full-tomato-btn w-full"
          //       text="تایید"
          //     />
          //   </div>
          // </div>
          <CreateCusotmerAddressStep
            CreateAddress={CreateAddress}
            data={values}
            currentData={EditAddress && Address}
            setAddressStep={setAddressStep}
            setEditAddress={setEditAddress}
            handleReset={handleReset}
            setAddress={setAddress}
          />
        ) : (
          <CreateCusotmerAddressStep
            CreateAddress={CreateAddress}
            data={values}
            currentData={EditAddress && Address}
            setAddressStep={setAddressStep}
            setEditAddress={setEditAddress}
            handleReset={handleReset}
            setAddress={setAddress}
          />
        )
      ) : (
        <BoxiAddresses CloseModal={CloseModal} setFieldValue={setFieldValue} />
      )}
      <div className="relative w-full">
        <span
          onClick={() => {
            setSenderType(!SenderType);
            handleReset();
            setAddress(undefined);
          }}
          className={`flex-start-center border border-tomato gap-3 rounded-full absolute z-50 px-5 py-1 bottom-3 left-3 cursor-pointer ${
            SenderType ? "bg-white" : "bg-tomato"
          }`}
        >
          <HubIcon className={`${!SenderType && "!text-white"}`} />
          <p className={`${SenderType ? "text-tomato" : "text-white"}`}>
            مراکز مجاز باکسیت
          </p>
        </span>
        <AddressSearchMap
          // notSearch
          wrapperClassName=" w-full sm:min-w-[20rem] md:min-w-[25rem] lg:min-w-[30rem] xl:min-sw-[50rem] h-full"
          id={orderData.fromCountryDevisionId}
          formik={formik}
          isDefaultLoc
        />
      </div>
    </div>
  );
};

export default SelectAddressStep;
